// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "." + "2fdc490f" + ".chunk.js"; };